/**
 * @fileoverview 共通モデル model
 *
 */
'use strict';
// Library Import
import _ from 'lodash';
import Backbone from 'backbone';
import 'backbone-validation';

/**
 * 共通Model
 *
 * @class CommonModel
 * @extends {Backbone.Model}
 */
class CommonModel extends Backbone.Model {
  constructor() {
    super();
    // Backbone ValidationをCollectionに取り込む
    _.extend(Backbone.Model.prototype, Backbone.Validation.mixin);
    // Backbone Validationのpatternを拡張(空文字対策)
    _.extend(Backbone.Validation.validators, {
      extendPattern: function(value, attr, customValue, model) {
        if (value !== '') {
          return Backbone.Validation.validators.pattern(
            value,
            attr,
            customValue,
            model
          );
        }
      },
      // Backbone Validation 一致しないパターン
      notEqual: function(value, attr, customValue, model) {
        if (value !== customValue) {
          return 'not match ' + customValue;
        }
      }
    });
  }

  /**
   * 拡張preValidate
   *
   * @name extendPreValidate
   * @function
   * @memberOf CommonModel
   * @param {Object} validationRule validationルール
   * @param {Object} data validationデータ
   * @return {string} エラー文字列
   */
  extendPreValidate(validationRule, data) {
    // validationルールをセット
    this.validation = validationRule;
    // validation対象
    let validationTarget = {};
    // チェック対象からvalidation対象を作成する
    for (let key of _.keys(this.validation)) {
      validationTarget[key] = '';
    }
    // validation対象にdataをマージする
    validationTarget = _.extend(validationTarget, data);
    // validationを行い結果を返す
    return this.preValidate(validationTarget);
  }

  /**
   * モデルにデータをセット
   *
   * @name setProperties
   * @function
   * @memberOf CommonModel
   * @param {Object} attributes 属性
   */
  setProperties(attributes) {
    this.attributes = {};
    _.extend(this.attributes, attributes);
  }
}
export default CommonModel;



// WEBPACK FOOTER //
// ./src/js/collection/model/CommonModel.jsx